<template>
  <div v-if="listBenhNhan.length > 0" class="col-md c-template-table table-responsive">
    <table class="table table-bordered table-more table-hover">
      <thead>
        <tr>
          <th class="th-number">#</th>
          <th>Bệnh nhân</th>
          <th class="text-center">Nhóm NC</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(benhNhan, index) in listBenhNhan" :key="benhNhan._id">
          <td class="th-number">{{ index + 1 }}</td>
          <td><benh-nhan-table-cell-basic-info :benhNhan="benhNhan" /></td>
          <td><benh-nhan-table-cell-tier :benhNhan="benhNhan" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BenhNhanTableCellBasicInfo from './BenhNhanTableCellBasicInfo';
import BenhNhanTableCellTier from './BenhNhanTableCellTier';

export default {
  components: {
    BenhNhanTableCellBasicInfo,
    BenhNhanTableCellTier,
  },
  props: {
    listBenhNhan: {
      type: Array,
      required: true,
      validator(listBenhNhan) {
        // make sure that listBenhNhan is a list of BenhNhan
        return listBenhNhan.every(item => !!item._id);
      },
    },
  },
};
</script>
